/*eslint-disable */
import React, { useState, useEffect } from "react";
import {
    Modal,
} from "semantic-ui-react";
import OrderAgGridTable from "../../../components/common/orderadGridTable";
import allAxiosCommonTA from "../../axiosComponent/allAxiosCommonTA";
import inputLRno from "../../common/inputField";
import inputLRDate from "../../common/inputDateField";
import allotVehicle from "../../common/allotVehicle";

const OwnVehiclePlanning = ({ ...props }) => {

    const [rowData, setRowData] = useState([]);
    const [bookingID, setBookingID] = useState(props?.props?.bookingIDClicked);

    var columnDefs = [
        {
            headerName: "SR. No.",
            //field: "", // source
            valueGetter: "node.rowIndex + 1",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Vehicle No.",
            field: "vehicle_number", // source
            minWidth: 180,
            sortable: true,
            filter: true,
        },
        {
            headerName: "LR No.",
            field: "", // source
            cellRenderer: "inputLRno",
            minWidth: 180,
            sortable: true,
            filter: true,
        },
        {
            headerName: "LR Date",
            field: "", // source
            cellRenderer: "inputLRDate",
            minWidth: 200,
            sortable: true,
            filter: true,
        },
        {
            headerName: "Vehicle Type",
            field: "vehicle_type", // source
            minWidth: 180,
            sortable: true,
            filter: true,
        },
        {
            headerName: "Status",
            field: "status", // source
            minWidth: 180,
            sortable: true,
            filter: true,
        },
        {
            headerName: "Idle Status",
            field: "idle_status", // source
            minWidth: 180,
            sortable: true,
            filter: true,
        },
        {
            headerName: "Empty KM Run",
            field: "empty_km_run", // source
            minWidth: 180,
            sortable: true,
            filter: true,
        },
        {
            headerName: "",
            field: "", // source
            cellRenderer: "allotVehicle",
            minWidth: 180,
            sortable: true,
            filter: true
        }
    ]

    useEffect(() => {
        getOwnVehicle()
    }, []);

    const getOwnVehicle = () => {
        allAxiosCommonTA({ url: "/vehicle/availability/booking/" + bookingID, method: "get", getValues: `ownership_type_id=1&` })
            .then((response) => {
                setRowData(response.data.data)
            })
            .catch((err) => {
                console.log("err", err);
            });
    }

    var frameworkcomponent = {
        inputLRno: inputLRno,
        inputLRDate: inputLRDate,
        allotVehicle: allotVehicle
    };

    return (
        <div>
            <OrderAgGridTable
                columnDefs={columnDefs}
                pagination={false}
                titleBarTitle=""
                extracomponents={frameworkcomponent}
                rowData={rowData}
                suppressRowClickSelection={true}
                enableCellChangeFlash={true}
                keyIndex={"u_id"}
                showFilter={false}
                bookingID={bookingID}
                ownershipTypeId='2'
            />
        </div>
    );
};

export default OwnVehiclePlanning;